import { ofType, combineEpics } from 'redux-observable';
import { takeUntil } from 'rxjs/operators';
import { CLEAR_ACTIVE_EXERCISE, SET_ACTIVE_EXERCISE } from '../app/actions';
import {
   initEpic,
   completeTutorialEpic,
   submitAnswerEpic,
   compareAnswerEpic,
   completeSessionEpic,
   loadModuleEpic,
   selectModulesEpic,
   updateAfterInitialSyncEpic,
   updatePermissionsEpic,
   advanceExerciseEpic,
   prepareNextSessionEpic,
   loadQueuedModulesEpic,
   queueModulesOnInitEpic,
   nextSessionReadyEpic,
   loadCurrentAuxiliraryEpic,
   awaitTutorialEpic,
   startNextSessionEpic,
   prepareNextChallengeEpic,
   nextChallengeReadyEpic,
   queueModulesOnFirstChallengeEpic,
   startNextChallengeEpic,
} from './epics';

const combineExerciseEpics =
   (...epics) =>
   (action$, ...rest) =>
      combineEpics(
         initEpic,
         advanceExerciseEpic,
         prepareNextSessionEpic,
         awaitTutorialEpic,
         nextSessionReadyEpic,
         startNextSessionEpic,
         completeTutorialEpic,
         prepareNextChallengeEpic,
         nextChallengeReadyEpic,
         startNextChallengeEpic,
         submitAnswerEpic,
         compareAnswerEpic,
         completeSessionEpic,
         loadModuleEpic,
         selectModulesEpic,
         updateAfterInitialSyncEpic,
         // updatePermissionsEpic,
         loadQueuedModulesEpic,
         loadCurrentAuxiliraryEpic,
         queueModulesOnInitEpic,
         queueModulesOnFirstChallengeEpic,
         ...epics
      )(action$, ...rest).pipe(
         takeUntil(
            action$.pipe(ofType(SET_ACTIVE_EXERCISE, CLEAR_ACTIVE_EXERCISE))
         )
      );

export { combineExerciseEpics };
